import { defineComponent } from "vue";
import BaseModal from "@/components/Shared/Modals/BaseModal/BaseModal.vue";

export default defineComponent({
  components: {
    BaseModal,
  },
  methods: {
    toggleModal(status: boolean) {
      const el: any = this.$refs["base-modal"];
      el.toggleBaseModal(status);
    },
    reloadPage() {
      document.location.reload();
    },
  },
});
